module.exports = {
	"ha": "fha",
	"id": 5.5,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Fraser Health by Age Category and MSM Status, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 92.5,
						"dataLabels": {
							"enabled": false,
							"format": "37"
						},
						"color": "#043f61"
					},
					{
						"y": 90,
						"dataLabels": {
							"enabled": false,
							"format": "36"
						},
						"color": "#0c4250"
					},
					{
						"y": 85,
						"dataLabels": {
							"enabled": false,
							"format": "34"
						},
						"color": "#0d4440"
					},
					{
						"y": 75,
						"dataLabels": {
							"enabled": false,
							"format": "30"
						},
						"color": "#09472e"
					},
					{
						"y": 60,
						"dataLabels": {
							"enabled": false,
							"format": "24"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 94.73684210526315,
						"dataLabels": {
							"enabled": false,
							"format": "108"
						},
						"color": "#043f61"
					},
					{
						"y": 78.94736842105263,
						"dataLabels": {
							"enabled": false,
							"format": "90"
						},
						"color": "#0c4250"
					},
					{
						"y": 74.56140350877193,
						"dataLabels": {
							"enabled": false,
							"format": "85"
						},
						"color": "#0d4440"
					},
					{
						"y": 70.17543859649122,
						"dataLabels": {
							"enabled": false,
							"format": "80"
						},
						"color": "#09472e"
					},
					{
						"y": 65.78947368421053,
						"dataLabels": {
							"enabled": false,
							"format": "75"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.61016949152543,
						"dataLabels": {
							"enabled": false,
							"format": "114"
						},
						"color": "#043f61"
					},
					{
						"y": 91.52542372881356,
						"dataLabels": {
							"enabled": false,
							"format": "108"
						},
						"color": "#0c4250"
					},
					{
						"y": 88.98305084745762,
						"dataLabels": {
							"enabled": false,
							"format": "105"
						},
						"color": "#0d4440"
					},
					{
						"y": 83.89830508474576,
						"dataLabels": {
							"enabled": false,
							"format": "99"
						},
						"color": "#09472e"
					},
					{
						"y": 70.33898305084746,
						"dataLabels": {
							"enabled": false,
							"format": "83"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.33333333333334,
						"dataLabels": {
							"enabled": false,
							"format": "438"
						},
						"color": "#043f61"
					},
					{
						"y": 94,
						"dataLabels": {
							"enabled": false,
							"format": "423"
						},
						"color": "#0c4250"
					},
					{
						"y": 91.33333333333333,
						"dataLabels": {
							"enabled": false,
							"format": "411"
						},
						"color": "#0d4440"
					},
					{
						"y": 88.44444444444444,
						"dataLabels": {
							"enabled": false,
							"format": "398"
						},
						"color": "#09472e"
					},
					{
						"y": 79.55555555555556,
						"dataLabels": {
							"enabled": false,
							"format": "358"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 94.73684210526315,
						"dataLabels": {
							"enabled": false,
							"format": "18"
						},
						"color": "#043f61"
					},
					{
						"y": 78.94736842105263,
						"dataLabels": {
							"enabled": false,
							"format": "15"
						},
						"color": "#0c4250"
					},
					{
						"y": 63.1578947368421,
						"dataLabels": {
							"enabled": false,
							"format": "12"
						},
						"color": "#0d4440"
					},
					{
						"y": 63.1578947368421,
						"dataLabels": {
							"enabled": false,
							"format": "12"
						},
						"color": "#09472e"
					},
					{
						"y": 57.89473684210527,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.3855421686747,
						"dataLabels": {
							"enabled": false,
							"format": "80"
						},
						"color": "#043f61"
					},
					{
						"y": 95.18072289156626,
						"dataLabels": {
							"enabled": false,
							"format": "79"
						},
						"color": "#0c4250"
					},
					{
						"y": 87.95180722891565,
						"dataLabels": {
							"enabled": false,
							"format": "73"
						},
						"color": "#0d4440"
					},
					{
						"y": 72.28915662650603,
						"dataLabels": {
							"enabled": false,
							"format": "60"
						},
						"color": "#09472e"
					},
					{
						"y": 59.036144578313255,
						"dataLabels": {
							"enabled": false,
							"format": "49"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.1038961038961,
						"dataLabels": {
							"enabled": false,
							"format": "222"
						},
						"color": "#043f61"
					},
					{
						"y": 89.17748917748918,
						"dataLabels": {
							"enabled": false,
							"format": "206"
						},
						"color": "#0c4250"
					},
					{
						"y": 84.4155844155844,
						"dataLabels": {
							"enabled": false,
							"format": "195"
						},
						"color": "#0d4440"
					},
					{
						"y": 73.59307359307358,
						"dataLabels": {
							"enabled": false,
							"format": "170"
						},
						"color": "#09472e"
					},
					{
						"y": 58.44155844155844,
						"dataLabels": {
							"enabled": false,
							"format": "135"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.80365296803653,
						"dataLabels": {
							"enabled": false,
							"format": "424"
						},
						"color": "#043f61"
					},
					{
						"y": 89.49771689497716,
						"dataLabels": {
							"enabled": false,
							"format": "392"
						},
						"color": "#0c4250"
					},
					{
						"y": 86.0730593607306,
						"dataLabels": {
							"enabled": false,
							"format": "377"
						},
						"color": "#0d4440"
					},
					{
						"y": 80.59360730593608,
						"dataLabels": {
							"enabled": false,
							"format": "353"
						},
						"color": "#09472e"
					},
					{
						"y": 67.8082191780822,
						"dataLabels": {
							"enabled": false,
							"format": "297"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 67.14285714285714,
						"dataLabels": {
							"enabled": false,
							"format": "47"
						},
						"color": "#043f61"
					},
					{
						"y": 58.57142857142858,
						"dataLabels": {
							"enabled": false,
							"format": "41"
						},
						"color": "#0c4250"
					},
					{
						"y": 54.285714285714285,
						"dataLabels": {
							"enabled": false,
							"format": "38"
						},
						"color": "#0d4440"
					},
					{
						"y": 44.285714285714285,
						"dataLabels": {
							"enabled": false,
							"format": "31"
						},
						"color": "#09472e"
					},
					{
						"y": 35.714285714285715,
						"dataLabels": {
							"enabled": false,
							"format": "25"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 94.23076923076923,
						"dataLabels": {
							"enabled": false,
							"format": "98"
						},
						"color": "#043f61"
					},
					{
						"y": 82.6923076923077,
						"dataLabels": {
							"enabled": false,
							"format": "86"
						},
						"color": "#0c4250"
					},
					{
						"y": 78.84615384615384,
						"dataLabels": {
							"enabled": false,
							"format": "82"
						},
						"color": "#0d4440"
					},
					{
						"y": 65.38461538461539,
						"dataLabels": {
							"enabled": false,
							"format": "68"
						},
						"color": "#09472e"
					},
					{
						"y": 56.730769230769226,
						"dataLabels": {
							"enabled": false,
							"format": "59"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.17224880382776,
						"dataLabels": {
							"enabled": false,
							"format": "201"
						},
						"color": "#043f61"
					},
					{
						"y": 81.81818181818183,
						"dataLabels": {
							"enabled": false,
							"format": "171"
						},
						"color": "#0c4250"
					},
					{
						"y": 78.94736842105263,
						"dataLabels": {
							"enabled": false,
							"format": "165"
						},
						"color": "#0d4440"
					},
					{
						"y": 72.24880382775119,
						"dataLabels": {
							"enabled": false,
							"format": "151"
						},
						"color": "#09472e"
					},
					{
						"y": 63.63636363636363,
						"dataLabels": {
							"enabled": false,
							"format": "133"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 95.21410579345087,
						"dataLabels": {
							"enabled": false,
							"format": "378"
						},
						"color": "#043f61"
					},
					{
						"y": 78.33753148614609,
						"dataLabels": {
							"enabled": false,
							"format": "311"
						},
						"color": "#0c4250"
					},
					{
						"y": 76.32241813602015,
						"dataLabels": {
							"enabled": false,
							"format": "303"
						},
						"color": "#0d4440"
					},
					{
						"y": 72.04030226700252,
						"dataLabels": {
							"enabled": false,
							"format": "286"
						},
						"color": "#09472e"
					},
					{
						"y": 60.70528967254408,
						"dataLabels": {
							"enabled": false,
							"format": "241"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -7.499999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.7027027027026973,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.555555555555558,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.764705882352944,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -5.263157894736848,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.555555555555558,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.882352941176472,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.3898305084745783,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.263157894736848,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.777777777777779,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.714285714285716,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.161616161616166,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.6666666666666616,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.424657534246578,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.8368794326241176,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.1630170316301665,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.050251256281406,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -5.263157894736848,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.333333333333337,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.6144578313253017,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -1.2499999999999956,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.594936708860756,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.808219178082197,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.8961038961038974,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.207207207207212,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.339805825242716,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.82051282051282,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -20.588235294117652,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.1963470319634757,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.547169811320753,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.826530612244894,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.366047745358094,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.864022662889521,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -32.85714285714286,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.765957446808507,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.317073170731703,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.42105263157895,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.354838709677423,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -5.769230769230771,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.244897959183676,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.651162790697672,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.07317073170732,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.235294117647056,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.8277511961722466,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.925373134328357,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.508771929824561,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.484848484848484,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.92052980132451,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -4.7858942065491235,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.72486772486772,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.5723472668810254,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.610561056105611,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.73426573426573,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=40"
			},
			{
				"x": 9,
				"text": "30-39<br>n=114"
			},
			{
				"x": 15,
				"text": "40-49<br>n=118"
			},
			{
				"x": 21,
				"text": ">=50<br>n=450"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=19"
			},
			{
				"x": 34,
				"text": "30-39<br>n=83"
			},
			{
				"x": 40,
				"text": "40-49<br>n=231"
			},
			{
				"x": 46,
				"text": ">=50<br>n=438"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=70"
			},
			{
				"x": 59,
				"text": "30-39<br>n=104"
			},
			{
				"x": 65,
				"text": "40-49<br>n=209"
			},
			{
				"x": 71,
				"text": ">=50<br>n=397"
			}
		],
		"dataTable": {
			"MSM:<30": [
				40,
				37,
				36,
				34,
				30,
				24
			],
			"MSM:30-39": [
				114,
				108,
				90,
				85,
				80,
				75
			],
			"MSM:40-49": [
				118,
				114,
				108,
				105,
				99,
				83
			],
			"MSM:>=50": [
				450,
				438,
				423,
				411,
				398,
				358
			],
			"Non-MSM:<30": [
				19,
				18,
				15,
				12,
				12,
				11
			],
			"Non-MSM:30-39": [
				83,
				80,
				79,
				73,
				60,
				49
			],
			"Non-MSM:40-49": [
				231,
				222,
				206,
				195,
				170,
				135
			],
			"Non-MSM:>=50": [
				438,
				424,
				392,
				377,
				353,
				297
			],
			"Unknown:<30": [
				70,
				47,
				41,
				38,
				31,
				25
			],
			"Unknown:30-39": [
				104,
				98,
				86,
				82,
				68,
				59
			],
			"Unknown:40-49": [
				209,
				201,
				171,
				165,
				151,
				133
			],
			"Unknown:>=50": [
				397,
				378,
				311,
				303,
				286,
				241
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_fha_5_5.json
// module id = 204
// module chunks = 0